module.exports = __webpack_public_path__ + "static/Bearbrick-eb50492384810421b55bfd1066cabac9.jpg";